import React, { useEffect } from "react";

import './Settings.css';

import Sidebar from "../sidebar/Sidebar";
import { Link, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { changePassword, isLoggedIn } from "../../features/login/loginSlice";
import { clearChangePasswordForm, selectNewPassword, selectUpdatePasswordResult } from "../../features/changePasswordForm/changePasswordFormSlice";
import { selectUser } from "../../features/home/userSlice";

export default function Settings() {
    const dispatch = useDispatch();
    const navigate = useNavigate();

    const loggedIn = useSelector(isLoggedIn);
    const newPassword = useSelector(selectNewPassword);
    const updatePasswordResult = useSelector(selectUpdatePasswordResult);

    const userInfo = useSelector(selectUser);
    const userRole = userInfo.userRole;

    useEffect(() => {
        if (!loggedIn) {
            navigate(`../login`);
        }
    }, [loggedIn, navigate])

    useEffect(() => {
        if (updatePasswordResult === "Password updated!") {
            dispatch(changePassword(newPassword));
        }
    }, [updatePasswordResult, newPassword, dispatch])

    return (
        <main>
            <Sidebar />
            <section className="settings">
                <h2>Settings</h2>
                <article className="user-settings">
                    <h3>User Settings</h3>
                    <h4>Name: {userInfo.name}</h4>
                    <h4>{userInfo.displayName ? `Display Name : ${userInfo.displayName}` : <Link to={`./editDisplayName`}><button>Create Display Name</button></Link>}</h4>
                    {userInfo.displayName ? <Link to={`./editDisplayName`}><button>Edit Display Name</button></Link> : ""}
                    <h4>Password: {userInfo.password}</h4>
                    {updatePasswordResult === "Password updated!" ? <p className="confirmation">{updatePasswordResult}</p> : ""}
                    <Link to={`./updatePassword`}><button onClick={() => dispatch(clearChangePasswordForm())}>Change Password</button></Link>
                </article>
                {userRole === 'User' ? <Link to={`./accountInfo`}>{'Account Information ->'}</Link> : ""}
            </section>
        </main>
    )
}